import { startingGold } from "../constants/startingGold";

// Utility functions
function rollDie(sides) {
  return Math.floor(Math.random() * sides) + 1;
}

function rollDice(num, sides, dropLowest = false) {
  const rolls = [];
  for (let i = 0; i < num; i++) {
    rolls.push(rollDie(sides));
  }
  if (dropLowest) {
    rolls.sort((a, b) => a - b);
    rolls.shift();
  }
  return rolls.reduce((sum, roll) => sum + roll, 0);
}

export const calculateGold = (character) => {

  try {
    const charClass = character.chars.myClass
    const GD = startingGold[charClass]
    console.log('Starting gold: ', GD)

    let Gold = rollDice(GD.dienumber,GD.dietype) * GD.multiplier

  if ( ['Fighter', 'Paladin', 'Ranger','Cleric'].some(str => charClass.includes(str)) ) {
    Gold -= 80 // pays for chainmail & weapon
  }
  if ( ['Druid', 'Thief', 'Assasin'].some(str => charClass.includes(str)) ) {
    Gold -= 20 // pays for leather & weapon
  }
  
    return Gold

  } catch(error) {
  console.log(error)
  return 20
  }
}